export default __webpack_public_path__ + "static/media/sharing.a41d0799.svg";